import { render } from "./SettingsComponents.vue?vue&type=template&id=2fc15614&scoped=true"
import script from "./SettingsComponents.vue?vue&type=script&lang=js"
export * from "./SettingsComponents.vue?vue&type=script&lang=js"

import "./SettingsComponents.vue?vue&type=style&index=0&id=2fc15614&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc15614"]])

export default __exports__